<template>
  <div class="s-checkbox" @click.stop="changeValue">
    <img class="icon" v-if="value" src="https://o.666visa.cn/static/ssqpeer/order/icon-checkbox-active.png" alt="">
    <img class="icon" v-else src="https://o.666visa.cn/static/ssqpeer/order/icon-checkbox.png" alt="">
    <slot>
      <div v-if="label" class="checkbox-label">{{label}}</div>
    </slot>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    changeValue() {
      this.$emit('input', !this.value);
    },
  },
};
</script>
<style lang="less" scoped>
.s-checkbox{
  display: inline-flex;
  align-items: center;
  font-size: 0;
  cursor: pointer;
  .icon{
    width: 18px;
    height: 18px;
  }
  .checkbox-label{
    margin-left: 4px;
    color: #2F333D;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/s-checkbox.vue